import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const CURRENCIES = [
  { code: "CAD", name: "Canadian Dollar", flag: "🇨🇦" },
  { code: "USD", name: "United States Dollar", flag: "🇺🇸" },
  { code: "GBP", name: "British Pound", flag: "🇬🇧" },
  { code: "EUR", name: "Euro", flag: "🇪🇺" },
  { code: "AUD", name: "Australian Dollar", flag: "🇦🇺" },
  { code: "NZD", name: "New Zealand Dollar", flag: "🇳🇿" },
  { code: "JPY", name: "Japanese Yen", flag: "🇯🇵" },
  { code: "CHF", name: "Swiss Franc", flag: "🇨🇭" },
  { code: "SEK", name: "Swedish Krona", flag: "🇸🇪" },
  { code: "NOK", name: "Norwegian Krone", flag: "🇳🇴" },
  { code: "DKK", name: "Danish Krone", flag: "🇩🇰" },
  { code: "MXN", name: "Mexican Peso", flag: "🇲🇽" },
  { code: "BRL", name: "Brazilian Real", flag: "🇧🇷" },
  { code: "INR", name: "Indian Rupee", flag: "🇮🇳" },
  { code: "SGD", name: "Singapore Dollar", flag: "🇸🇬" },
  { code: "HKD", name: "Hong Kong Dollar", flag: "🇭🇰" },
  { code: "ZAR", name: "South African Rand", flag: "🇿🇦" },
  { code: "AED", name: "UAE Dirham", flag: "🇦🇪" },
  { code: "PLN", name: "Polish Zloty", flag: "🇵🇱" },
  { code: "CZK", name: "Czech Koruna", flag: "🇨🇿" },
  { code: "HUF", name: "Hungarian Forint", flag: "🇭🇺" },
  { code: "ILS", name: "Israeli Shekel", flag: "🇮🇱" },
  { code: "PHP", name: "Philippine Peso", flag: "🇵🇭" },
  { code: "THB", name: "Thai Baht", flag: "🇹🇭" },
  { code: "MYR", name: "Malaysian Ringgit", flag: "🇲🇾" },
  { code: "IDR", name: "Indonesian Rupiah", flag: "🇮🇩" },
  { code: "KRW", name: "South Korean Won", flag: "🇰🇷" },
  { code: "CNY", name: "Chinese Yuan", flag: "🇨🇳" },
  { code: "TRY", name: "Turkish Lira", flag: "🇹🇷" },
  { code: "SAR", name: "Saudi Riyal", flag: "🇸🇦" },
  { code: "CLP", name: "Chilean Peso", flag: "🇨🇱" },
  { code: "COP", name: "Colombian Peso", flag: "🇨🇴" },
];

export function CurrencySelect({ value = "CAD", onChange }) {
  const [open, setOpen] = useState(false);
  const current = CURRENCIES.find((c) => c.code === value) || CURRENCIES[0];

  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} data-testid="currency-select-trigger"
          className="mt-1.5 w-full justify-between bg-secondary/50 font-normal">
          <span className="flex items-center gap-2">
            <span className="text-base">{current.flag}</span>
            {current.name} <span className="text-muted-foreground">({current.code})</span>
          </span>
          <ChevronsUpDown className="h-4 w-4 opacity-50 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search currency…" data-testid="currency-search-input" />
          <CommandList>
            <CommandEmpty>No currency found.</CommandEmpty>
            <CommandGroup>
              {CURRENCIES.map((c) => (
                <CommandItem key={c.code} value={`${c.name} ${c.code}`} data-testid={`currency-option-${c.code}`}
                  onSelect={() => { onChange(c.code); setOpen(false); }}>
                  <span className="text-base mr-2">{c.flag}</span>
                  <span className="flex-1">{c.name}</span>
                  <span className="text-muted-foreground text-xs mr-2">{c.code}</span>
                  <Check className={`h-4 w-4 ${value === c.code ? "opacity-100" : "opacity-0"}`} />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
